import styled from 'styled-components'
import { navTheme } from 'theme'
import { Button } from '@dasa-health/components-react'

export const CustomForm = styled.form`
    height: auto;
    max-width: 434px;

    .textInput > span {
        white-space: normal;
    }
`

export const FieldWithButton = styled.div`
    display: flex;
    align-items: center;
    margin-top: 1.5rem;
    align-self: center;
`

export const ForgotPasswordButton = styled.button<{ passwordValidation: boolean }>`
    margin-top: ${({ passwordValidation }) => (passwordValidation ? '16px' : '0')};
    border: 0;
    background-color: transparent;
    font-size: 0.875rem;
    color: ${navTheme.colors.interaction.accent['01']};
    text-decoration: underline;
    cursor: pointer;
    align-self: flex-end;
`

export const ButtonOTP = styled(Button)`
    &&& {
        margin-top: 1.5rem;
    }
`

export const ButtonCIP = styled(Button)`
    &&& {
        margin-top: 2rem;
        margin-bottom: 1rem;
    }
`
